















































import mixins from "vue-typed-mixins";

/** Mixins */
import { ProfileMixin } from "@/mixins/participant-general-mixin";

/** Components */
import ParticipantSmallInfoCard from "@/components/participant/participant-small-info-card.vue";

export default mixins(ProfileMixin).extend({
  name: "MeasurementsHeading",
  components: {
    ParticipantSmallInfoCard,
  },
  computed: {
    mostConsumingApplianceSubtitle() {
      const { subtitle } = this.getMostConsumingApplianceDetails();

      /** In case the appliance is yet to be determined */
      if (subtitle === this.$t("components.cards.label.toDetermine")) {
        return subtitle;
      }

      const appliance = this.$t(
        `devices.${subtitle
          ?.toLowerCase()
          ?.replaceAll(" ", "_")
          ?.normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")}`
      );

      return `${appliance}`;
    },
    mostConsumingApplianceConsumption() {
      const { consumption } = this.getMostConsumingApplianceDetails();
      return consumption;
    },
  },
});
